export default {
  items: [
    {
      name: "Registration",
      url: "/keyholder/registration",
      icon: "fa fa-gears fa-lg",
      attributes: { "data-cy": "registration" },
    },
  ],
};
